import styled from 'styled-components';

export const DesktopFilterWrapper = styled.div<{ isDisabled: boolean }>`
  display: flex;
  background-color: white;
  border: 1px solid #e6e7e8;
  border-radius: 3px;
  opacity: ${(props) => (props.isDisabled ? '0.6' : '1')};
  pointer-events: ${(props) => (props.isDisabled ? 'none' : 'auto')};
`;

export const PropertyInputWrapper = styled.div`
  flex: 5;
`;

export const PriceInputWrapper = styled.div`
  flex: 6;
`;

interface ClearButtonWrapperProps {
  isDisabled: boolean;
}

export const ClearButtonWrapper = styled.div<ClearButtonWrapperProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px;
  cursor: ${(props) => `${props.isDisabled ? 'default' : 'pointer'}`};
  color: ${(props) => `${props.isDisabled ? '#a5adb5' : '#333F48'}`};

  &:hover {
    background: ${(props) => `${props.isDisabled ? '' : '#F7F8F9'}`};
  }
`;
